const ENV_VALUES = {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ENABLE_LOCAL_DEV_AUTH: process.env.REACT_APP_ENABLE_LOCAL_DEV_AUTH,
  REACT_APP_LOCAL_DEV_PRIMARY_COMPANY_PASSWORD: process.env.REACT_APP_LOCAL_DEV_PRIMARY_COMPANY_PASSWORD,
  REACT_APP_LOCAL_DEV_COMPANY_PASSWORD: process.env.REACT_APP_LOCAL_DEV_COMPANY_PASSWORD,
  REACT_APP_LOCAL_DEV_PRIMARY_USER_PASSWORD: process.env.REACT_APP_LOCAL_DEV_PRIMARY_USER_PASSWORD,
  REACT_APP_LOCAL_DEV_ADMIN_PASSWORD: process.env.REACT_APP_LOCAL_DEV_ADMIN_PASSWORD,
  REACT_APP_LOCAL_DEV_MANAGER_PASSWORD: process.env.REACT_APP_LOCAL_DEV_MANAGER_PASSWORD,
  REACT_APP_LOCAL_DEV_TEAM_PASSWORD: process.env.REACT_APP_LOCAL_DEV_TEAM_PASSWORD,
};

const envValue = key => ENV_VALUES[key];

const isDevelopment = envValue('NODE_ENV') === 'development';
const devFallback = value => (isDevelopment ? value : undefined);
export const isLocalDevAuthEnabled = () => (
  isDevelopment && envValue('REACT_APP_ENABLE_LOCAL_DEV_AUTH') === 'true'
);

const LOCAL_DEV_PRIMARY_COMPANY_PASSWORD = envValue('REACT_APP_LOCAL_DEV_PRIMARY_COMPANY_PASSWORD');
const LOCAL_DEV_COMPANY_PASSWORD = envValue('REACT_APP_LOCAL_DEV_COMPANY_PASSWORD') || devFallback('PutPens@2026');
const LOCAL_DEV_PRIMARY_USER_PASSWORD = envValue('REACT_APP_LOCAL_DEV_PRIMARY_USER_PASSWORD');
const LOCAL_DEV_ADMIN_PASSWORD = envValue('REACT_APP_LOCAL_DEV_ADMIN_PASSWORD') || devFallback('Admin@2026');
const LOCAL_DEV_MANAGER_PASSWORD = envValue('REACT_APP_LOCAL_DEV_MANAGER_PASSWORD') || devFallback('Manager@2026');
const LOCAL_DEV_TEAM_PASSWORD = envValue('REACT_APP_LOCAL_DEV_TEAM_PASSWORD') || devFallback('Team@2026');

export const LOCAL_DEV_COMPANIES = [
  {
    id: 'local-dev-company',
    name: 'PutPens Local',
    password: LOCAL_DEV_PRIMARY_COMPANY_PASSWORD,
  },
  {
    id: 'putpens-admin-company',
    name: 'PutPens App',
    password: LOCAL_DEV_COMPANY_PASSWORD,
  },
].filter(company => Boolean(company.password));

const primaryCompany = LOCAL_DEV_COMPANIES.find(company => company.id === 'local-dev-company');
const appCompany = LOCAL_DEV_COMPANIES.find(company => company.id === 'putpens-admin-company');

export const LOCAL_DEV_USERS = [
  {
    id: 1,
    email: 'user@putpens.local',
    password: LOCAL_DEV_PRIMARY_USER_PASSWORD,
    role: 'admin',
    designation: 'Admin',
    company: primaryCompany,
  },
  {
    id: 101,
    email: 'admin@putpens.local',
    password: LOCAL_DEV_ADMIN_PASSWORD,
    role: 'admin',
    designation: 'Admin',
    company: appCompany,
  },
  {
    id: 111,
    email: 'localadmin@putpens.local',
    password: LOCAL_DEV_ADMIN_PASSWORD,
    role: 'admin',
    designation: 'Admin',
    company: appCompany,
  },
  {
    id: 102,
    email: 'manager@putpens.local',
    password: LOCAL_DEV_MANAGER_PASSWORD,
    role: 'manager',
    designation: 'Manager',
    company: appCompany,
  },
  {
    id: 112,
    email: 'localmanager@putpens.local',
    password: LOCAL_DEV_MANAGER_PASSWORD,
    role: 'manager',
    designation: 'Manager',
    company: appCompany,
  },
  {
    id: 103,
    email: 'team@putpens.local',
    password: LOCAL_DEV_TEAM_PASSWORD,
    role: 'team_member',
    designation: 'Team Member',
    company: appCompany,
  },
  {
    id: 113,
    email: 'localteam@putpens.local',
    password: LOCAL_DEV_TEAM_PASSWORD,
    role: 'team_member',
    designation: 'Team Member',
    company: appCompany,
  },
].filter(user => Boolean(user.password) && Boolean(user.company));

export const LOCAL_DEV_PROJECTS = [
  {
    id: 1,
    name: 'Local Demo Project',
    start_date: '2026-05-01',
    end_date: '2026-05-31',
    status: 'ongoing',
    manager: LOCAL_DEV_USERS.find(user => user.role === 'manager'),
    company: appCompany,
  },
  {
    id: 2,
    name: 'Completed Demo Project',
    start_date: '2026-04-01',
    end_date: '2026-04-30',
    status: 'completed',
    manager: LOCAL_DEV_USERS.find(user => user.role === 'manager'),
    company: appCompany,
  },
].filter(project => Boolean(project.company));

const LOCAL_DEV_USERS_STORAGE_KEY = 'local_dev_users';
const LOCAL_DEV_PROJECTS_STORAGE_KEY = 'local_dev_projects';

const formatLocalDevDateTime = (date) => {
  const timezoneOffsetMs = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - timezoneOffsetMs).toISOString().slice(0, 19);
};

const getLocalDevDateAtHour = (daysFromToday, hour) => {
  const date = new Date();
  date.setDate(date.getDate() + daysFromToday);
  date.setHours(hour, 0, 0, 0);
  return formatLocalDevDateTime(date);
};

const getLocalDevHoursFromNow = (hours) => {
  const date = new Date();
  date.setHours(date.getHours() + hours, 0, 0, 0);
  return formatLocalDevDateTime(date);
};

export const LOCAL_DEV_SUBTASKS = [
  {
    id: 101,
    name: 'सबटास्क 1.1 - प्रारंभिक जांच',
    description: 'हिंदी टेस्ट डेटा: मेजर टास्क 1 का एक सबटास्क, पूरा करने का समय 4 घंटे बाद।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevHoursFromNow(4),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 101,
    major_task: {
      id: 101,
      name: 'मेजर टास्क 1',
      description: 'हिंदी टेस्ट डेटा - 1 सबटास्क',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 201,
    name: 'सबटास्क 2.1 - सुबह की गतिविधि',
    description: 'हिंदी टेस्ट डेटा: दूसरे दिन का पहला सबटास्क।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevDateAtHour(1, 10),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 201,
    major_task: {
      id: 201,
      name: 'मेजर टास्क 2',
      description: 'हिंदी टेस्ट डेटा - 3 सबटास्क, हर एक में 4 घंटे का अंतर',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 202,
    name: 'सबटास्क 2.2 - दोपहर की गतिविधि',
    description: 'हिंदी टेस्ट डेटा: दूसरे दिन का दूसरा सबटास्क।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevDateAtHour(1, 14),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 201,
    major_task: {
      id: 201,
      name: 'मेजर टास्क 2',
      description: 'हिंदी टेस्ट डेटा - 3 सबटास्क, हर एक में 4 घंटे का अंतर',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 203,
    name: 'सबटास्क 2.3 - शाम की गतिविधि',
    description: 'हिंदी टेस्ट डेटा: दूसरे दिन का तीसरा सबटास्क।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevDateAtHour(1, 18),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 201,
    major_task: {
      id: 201,
      name: 'मेजर टास्क 2',
      description: 'हिंदी टेस्ट डेटा - 3 सबटास्क, हर एक में 4 घंटे का अंतर',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 301,
    name: 'सबटास्क 3.1 - पहला चरण',
    description: 'हिंदी टेस्ट डेटा: तीसरे दिन का पहला सबटास्क।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevDateAtHour(2, 10),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 301,
    major_task: {
      id: 301,
      name: 'मेजर टास्क 3',
      description: 'हिंदी टेस्ट डेटा - 2 सबटास्क, हर एक में 4 घंटे का अंतर',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 302,
    name: 'सबटास्क 3.2 - दूसरा चरण',
    description: 'हिंदी टेस्ट डेटा: तीसरे दिन का दूसरा सबटास्क।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevDateAtHour(2, 14),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 301,
    major_task: {
      id: 301,
      name: 'मेजर टास्क 3',
      description: 'हिंदी टेस्ट डेटा - 2 सबटास्क, हर एक में 4 घंटे का अंतर',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 401,
    name: 'सबटास्क 4.1 - पहला काम',
    description: 'हिंदी टेस्ट डेटा: चौथे दिन का पहला सबटास्क।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevDateAtHour(3, 10),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 401,
    major_task: {
      id: 401,
      name: 'मेजर टास्क 4',
      description: 'हिंदी टेस्ट डेटा - 3 सबटास्क, हर एक में 4 घंटे का अंतर',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 402,
    name: 'सबटास्क 4.2 - दूसरा काम',
    description: 'हिंदी टेस्ट डेटा: चौथे दिन का दूसरा सबटास्क।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevDateAtHour(3, 14),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 401,
    major_task: {
      id: 401,
      name: 'मेजर टास्क 4',
      description: 'हिंदी टेस्ट डेटा - 3 सबटास्क, हर एक में 4 घंटे का अंतर',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 403,
    name: 'सबटास्क 4.3 - तीसरा काम',
    description: 'हिंदी टेस्ट डेटा: चौथे दिन का तीसरा सबटास्क।',
    status: 'ongoing',
    priority: 'medium',
    due_date: getLocalDevDateAtHour(3, 18),
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 401,
    major_task: {
      id: 401,
      name: 'मेजर टास्क 4',
      description: 'हिंदी टेस्ट डेटा - 3 सबटास्क, हर एक में 4 घंटे का अंतर',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 1,
    name: 'Review site progress photos',
    status: 'ongoing',
    due_date: '2026-05-07T17:30:00+05:30',
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 1,
    major_task: {
      id: 1,
      name: 'Daily Progress Check',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 2,
    name: 'Approve material checklist',
    status: 'pending_approval',
    due_date: '2026-05-07T18:00:00+05:30',
    assigned_to: LOCAL_DEV_USERS[3],
    major_task_id: 2,
    major_task: {
      id: 2,
      name: 'Procurement Follow-up',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
  {
    id: 3,
    name: 'Prepare tomorrow work plan',
    status: 'ongoing',
    due_date: '2026-05-08T10:00:00+05:30',
    assigned_to: LOCAL_DEV_USERS[2],
    major_task_id: 3,
    major_task: {
      id: 3,
      name: 'Planning',
      project: LOCAL_DEV_PROJECTS[0],
    },
  },
];

export const LOCAL_DEV_NOTIFICATIONS = [
  {
    id: 1,
    is_read: false,
    notification: {
      type: 'task_assignment',
      message: 'New subtask assigned: Review site progress photos.',
      message_hi: 'नया सबटास्क असाइन किया गया: साइट प्रगति फोटो की समीक्षा करें।',
      created_by: 'manager@putpens.local',
      created_at: '2026-05-07T10:30:00+05:30',
    },
    recipient_email: 'team@putpens.local',
  },
  {
    id: 2,
    is_read: false,
    notification: {
      type: 'task_pending_approval',
      message: 'Team member has submitted the task \'Approve material checklist\' for your approval.',
      message_hi: 'टीम सदस्य ने जमा किया: सामग्री चेकलिस्ट स्वीकृत करें।',
      created_by: 'team@putpens.local',
      created_at: '2026-05-07T11:15:00+05:30',
    },
    recipient_email: 'manager@putpens.local',
  },
  {
    id: 3,
    is_read: true,
    notification: {
      type: 'deadline_reminder',
      message: 'Local Demo Project has tasks due today.',
      message_hi: 'लोकल डेमो प्रोजेक्ट के कार्य आज देय हैं।',
      created_by: 'System',
      created_at: '2026-05-07T09:00:00+05:30',
    },
    recipient_email: 'admin@putpens.local',
  },
];

export const findLocalDevCompany = (name, password) => (
  LOCAL_DEV_COMPANIES.find(company => (
    company.name.toLowerCase() === String(name || '').trim().toLowerCase() &&
    company.password === String(password || '').trim()
  ))
);

const LOCAL_NOTIFICATION_HI_BY_MESSAGE = {
  'New subtask assigned: Review site progress photos.': 'नया सबटास्क असाइन किया गया: साइट प्रगति फोटो की समीक्षा करें।',
  'Team member submitted: Approve material checklist.': 'टीम सदस्य ने जमा किया: सामग्री चेकलिस्ट स्वीकृत करें।',
  'Local Demo Project has tasks due today.': 'लोकल डेमो प्रोजेक्ट के कार्य आज देय हैं।',
};

const looksLikeBrokenHindi = value => /(?:Ã.|Â.|â.|ðŸ|à[¤¥])/.test(String(value || ''));

const repairBrokenHindi = value => {
  const text = String(value || '');
  if (!looksLikeBrokenHindi(text)) return text;
  try {
    const encoded = Array.from(text).map(char => {
      const code = char.charCodeAt(0);
      return code <= 255 ? `%${code.toString(16).padStart(2, '0')}` : char;
    }).join('');
    return decodeURIComponent(encoded);
  } catch (error) {
    return text;
  }
};

const repairLocalDevHindiFields = value => {
  if (Array.isArray(value)) {
    return value.map(repairLocalDevHindiFields);
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, repairLocalDevHindiFields(item)])
    );
  }
  return typeof value === 'string' ? repairBrokenHindi(value) : value;
};

const getHindiFallbackForNotification = ({ type, message }) => {
  if (LOCAL_NOTIFICATION_HI_BY_MESSAGE[message]) {
    return LOCAL_NOTIFICATION_HI_BY_MESSAGE[message];
  }

  const assignmentMatch = String(message || '').match(/^Subtask '(.+)' assigned by (.+)\.$/);
  if (assignmentMatch && type === 'task_assignment') {
    return `सबटास्क '${assignmentMatch[1]}' ${assignmentMatch[2]} द्वारा असाइन किया गया है।`;
  }

  const assignedToMatch = String(message || '').match(/^Subtask '(.+)' assigned to (.+)\.$/);
  if (assignedToMatch && type === 'task_assignment') {
    return `सबटास्क '${assignedToMatch[1]}' ${assignedToMatch[2]} को असाइन किया गया है।`;
  }

  const approvalMatch = String(message || '').match(/^Task submitted for approval: (.+)\.$/);
  if (approvalMatch && ['task_submission', 'task_pending_approval'].includes(type)) {
    return `कार्य '${approvalMatch[1]}' स्वीकृति के लिए जमा किया गया है।`;
  }

  return '';
};

const normalizeLocalDevNotification = item => {
  const notification = item?.notification || {};
  const fallbackHindi = getHindiFallbackForNotification({
    type: notification.type,
    message: notification.message,
  });

  return {
    ...item,
    notification: {
      ...notification,
      message_hi: repairBrokenHindi(
        looksLikeBrokenHindi(notification.message_hi)
          ? fallbackHindi || notification.message
          : notification.message_hi || fallbackHindi || notification.message
      ),
    },
  };
};

const normalizeRole = role => {
  const value = String(role || '').trim().toLowerCase().replace(/\s+/g, '_');
  if (value === 'team' || value === 'team-member' || value === 'team_member') return 'team_member';
  if (value === 'manager') return 'manager';
  if (value === 'admin') return 'admin';
  return value;
};

export const findLocalDevUser = ({ companyId, email, password, role }) => {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  const normalizedPassword = String(password || '').trim();
  const normalizedRole = normalizeRole(role);

  return LOCAL_DEV_USERS.find(user => (
    user.company.id === companyId &&
    user.email === normalizedEmail &&
    user.password === normalizedPassword &&
    user.role === normalizedRole
  )) || LOCAL_DEV_USERS.find(user => (
    user.email === normalizedEmail &&
    user.password === normalizedPassword &&
    user.role === normalizedRole
  ));
};

export const toStoredLocalUser = user => ({
  id: user.id,
  email: user.email,
  role: user.role,
  designation: user.designation,
  company: {
    id: user.company.id,
    name: user.company.name,
  },
});

export const isLocalDevCompanyId = companyId => (
  LOCAL_DEV_COMPANIES.some(company => company.id === companyId)
);

export const getLocalDevUsers = (companyId) => {
  const storedUsers = JSON.parse(localStorage.getItem(LOCAL_DEV_USERS_STORAGE_KEY) || '[]');
  const users = [...LOCAL_DEV_USERS, ...storedUsers];
  if (!companyId) return users;
  return users.filter(user => user.company?.id === companyId);
};

export const addLocalDevUser = ({ email, password, role, designation, mobile_number, companyId, managerId }) => {
  const company = LOCAL_DEV_COMPANIES.find(item => item.id === companyId);
  if (!company) {
    throw new Error('Local company not found.');
  }

  const existingUsers = getLocalDevUsers(companyId);
  const normalizedEmail = String(email || '').trim().toLowerCase();

  if (existingUsers.some(user => user.email === normalizedEmail)) {
    throw new Error('A user with this email already exists.');
  }

  const nextId = Math.max(0, ...getLocalDevUsers().map(user => Number(user.id) || 0)) + 1;
  const manager = role === 'team_member'
    ? getLocalDevUsers(companyId).find(user => String(user.id) === String(managerId))
    : null;

  if (role === 'team_member' && !manager) {
    throw new Error('Please assign a manager.');
  }

  const storedUsers = JSON.parse(localStorage.getItem(LOCAL_DEV_USERS_STORAGE_KEY) || '[]');
  const user = {
    id: nextId,
    email: normalizedEmail,
    password: String(password || '').trim(),
    role,
    designation: designation || '',
    mobile_number: mobile_number || '',
    company,
    ...(manager ? { manager } : {}),
  };

  localStorage.setItem(LOCAL_DEV_USERS_STORAGE_KEY, JSON.stringify([user, ...storedUsers]));
  return user;
};

export const getLocalDevProjects = (companyId) => {
  const storedProjects = JSON.parse(localStorage.getItem(LOCAL_DEV_PROJECTS_STORAGE_KEY) || '[]');
  const projects = [...LOCAL_DEV_PROJECTS, ...storedProjects];
  if (!companyId) return projects;
  return projects.filter(project => project.company?.id === companyId);
};

export const addLocalDevProject = ({ name, start_date, end_date, manager_id, status, companyId }) => {
  const company = LOCAL_DEV_COMPANIES.find(item => item.id === companyId);
  if (!company) {
    throw new Error('Local company not found.');
  }

  const manager = getLocalDevUsers(companyId).find(user => String(user.id) === String(manager_id));
  if (!manager) {
    throw new Error('Please select a valid manager.');
  }

  const nextId = Math.max(0, ...getLocalDevProjects().map(project => Number(project.id) || 0)) + 1;
  const storedProjects = JSON.parse(localStorage.getItem(LOCAL_DEV_PROJECTS_STORAGE_KEY) || '[]');
  const project = {
    id: nextId,
    name: String(name || '').trim(),
    start_date,
    end_date,
    status,
    manager,
    company,
  };

  localStorage.setItem(LOCAL_DEV_PROJECTS_STORAGE_KEY, JSON.stringify([project, ...storedProjects]));
  return project;
};

const getLocalDevReadNotificationIds = email => (
  JSON.parse(localStorage.getItem(`local_dev_read_notifications_${email}`) || '[]')
);

export const getLocalDevNotifications = email => (
  [
    ...LOCAL_DEV_NOTIFICATIONS,
    ...JSON.parse(localStorage.getItem('local_dev_notifications') || '[]'),
  ].filter(item => item.recipient_email === email)
    .map(normalizeLocalDevNotification)
    .map(item => ({
      ...item,
      is_read: item.is_read || getLocalDevReadNotificationIds(email).includes(item.id),
    }))
);

export const markLocalDevNotificationsRead = email => {
  const notifications = getLocalDevNotifications(email);
  const readIds = Array.from(new Set([
    ...getLocalDevReadNotificationIds(email),
    ...notifications.map(item => item.id),
  ]));
  localStorage.setItem(`local_dev_read_notifications_${email}`, JSON.stringify(readIds));
};

export const getLocalDevSubtasks = () => (
  [
    ...LOCAL_DEV_SUBTASKS,
    ...JSON.parse(localStorage.getItem('local_dev_subtasks') || '[]'),
  ].map(repairLocalDevHindiFields)
);

export const updateLocalDevSubtask = (taskId, updates = {}) => {
  const stored = JSON.parse(localStorage.getItem('local_dev_subtasks') || '[]');
  const staticTask = LOCAL_DEV_SUBTASKS.find(task => String(task.id) === String(taskId));
  const storedTask = stored.find(task => String(task.id) === String(taskId));
  const updatedTask = {
    ...(storedTask || staticTask),
    ...updates,
    updated_at: new Date().toISOString(),
  };

  if (!updatedTask.id) return null;

  const nextStored = [
    updatedTask,
    ...stored.filter(task => String(task.id) !== String(taskId)),
  ];
  localStorage.setItem('local_dev_subtasks', JSON.stringify(nextStored));
  return updatedTask;
};

export const addLocalDevSubtask = ({ majorTask, subtask, assignedTo, assignedBy }) => {
  const stored = JSON.parse(localStorage.getItem('local_dev_subtasks') || '[]');
  const item = {
    id: `local-subtask-${Date.now()}-${stored.length}`,
    name: subtask.name,
    description: subtask.description || '',
    status: subtask.status || 'ongoing',
    priority: subtask.priority || 'medium',
    due_date: subtask.due_datetime,
    assigned_to: assignedTo,
    assigned_by: assignedBy,
    is_daily_activity: !!subtask.is_daily_activity,
    major_task_id: majorTask.id,
    major_task: majorTask,
  };
  localStorage.setItem('local_dev_subtasks', JSON.stringify([item, ...stored]));
  return item;
};

export const addLocalDevNotification = ({ recipientEmail, type, message, messageHi, createdBy }) => {
  const stored = JSON.parse(localStorage.getItem('local_dev_notifications') || '[]');
  const item = {
    id: `local-${Date.now()}-${stored.length}`,
    is_read: false,
    notification: {
      type,
      message,
      message_hi: messageHi || message,
      created_by: createdBy || 'System',
      created_at: new Date().toISOString(),
    },
    recipient_email: recipientEmail,
  };
  localStorage.setItem('local_dev_notifications', JSON.stringify([item, ...stored]));
  return item;
};
